// Kleine Wörter, die mehrere Ansichten brauchen

/** K28 (Fabi, Runde 7): Tempo in Worten */
export function speedWord(v: number): string {
  return v < 15 ? 'gemächlich' : v < 21 ? 'gemütlich' : v < 30 ? 'flink' : 'blitzschnell';
}

/** P10 (Fabi, Abschlusstest Phase 4): Reichweite auf Karte und Info-Tafel im selben Wortlaut, bei Fernkampf mit Wert */
export function rangeWord(range: number): string {
  return range > 10 ? `Fernkampf (${Math.round(range)})` : 'Nahkampf';
}
